import { PDFReportQuery } from 'api/ProductAnalyticsAPI';
import * as actionTypes from './actionTypes';

export function exportReportDataAsCsvRequest(
  reportData: Record<string, any>,
  callback: (data: string) => void,
) {
  return {
    type: actionTypes.EXPORT_INSIGHT_REPORT_DATA_AS_CSV_REQUEST,
    reportData,
    callback,
  };
}

export function exportReportDataAsCsvResponse(csvData: string) {
  return {
    type: actionTypes.EXPORT_INSIGHT_REPORT_DATA_AS_CSV_RESPONSE,
    csvData,
  };
}

export function exportReportDataAsCsvError(error: string) {
  return {
    type: actionTypes.EXPORT_INSIGHT_REPORT_DATA_AS_CSV_ERROR,
    error,
  };
}

export const fetchXMedAggStatsForTimeRange = (queryData: Record<string, any>) => {
  return {
    type: actionTypes.FETCH_X_MED_AGG_STATS_FOR_TIME_RANGE_REQUEST,
    queryData,
  };
};

export const recieveXMedAggStatsForTimeRange = (overallPerformanceData: Record<string, any>) => {
  return {
    type: actionTypes.FETCH_X_MED_AGG_STATS_FOR_TIME_RANGE_RESPONSE,
    overallPerformanceData,
  };
};

export const recieveXMedAggStatsForTimeRangeError = (error: string) => {
  return {
    type: actionTypes.FETCH_X_MED_AGG_STATS_FOR_TIME_RANGE_ERROR,
    error,
  };
};

export const fetchTimeSeriesDataRequest = (queryData: Record<string, any>) => ({
  type: actionTypes.FETCH_TIME_SERIES_DATA_FOR_TIME_RANGE_REQUEST,
  queryData,
});

export const fetchTimeSeriesDataSuccess = (data: Record<string, any>) => ({
  type: actionTypes.FETCH_TIME_SERIES_DATA_FOR_TIME_RANGE_RESPONSE,
  payload: data,
});

export const fetchTimeSeriesDataFailure = (error: string) => ({
  type: actionTypes.FETCH_TIME_SERIES_DATA_FOR_TIME_RANGE_ERROR,
  error,
});

export const fetchLocationDataRequest = (queryData: Record<string, any>) => ({
  type: actionTypes.FETCH_LOCATION_DATA_FOR_TIME_RANGE_REQUEST,
  payload: queryData,
});

export const fetchLocationDataSuccess = (data: Record<string, any>) => ({
  type: actionTypes.FETCH_LOCATION_DATA_FOR_TIME_RANGE_RESPONSE,
  payload: data,
});

export const fetchLocationDataFailure = (error: string) => ({
  type: actionTypes.FETCH_LOCATION_DATA_FOR_TIME_RANGE_ERROR,
  error,
});

export const fetchDeviceDataRequest = (queryData: Record<string, any>) => ({
  type: actionTypes.FETCH_DEVICE_DATA_FOR_TIME_RANGE_REQUEST,
  payload: queryData,
});

export const fetchDeviceDataSuccess = (data: Record<string, any>) => ({
  type: actionTypes.FETCH_DEVICE_DATA_FOR_TIME_RANGE_RESPONSE,
  payload: data,
});

export const fetchDeviceDataFailure = (error: string) => ({
  type: actionTypes.FETCH_DEVICE_DATA_FOR_TIME_RANGE_ERROR,
  error,
});

export const fetchSegments = (queryData: Record<string, any>) => {
  return {
    type: actionTypes.FETCH_SEGMENTS_REQUEST,
    queryData,
  };
};

export const recieveSegmentsResponse = (segmentData: Record<string, any>) => {
  return {
    type: actionTypes.FETCH_SEGMENTS_RESPONSE,
    segmentData,
  };
};

export const recieveSegmentsError = (error: string) => {
  return {
    type: actionTypes.FETCH_SEGMENTS_ERROR,
    error,
  };
};

export const fetchSegmentsV2Request = (queryData: any) => {
  return {
    type: actionTypes.FETCH_SEGMENTSV2_REQUEST,
    queryData,
  };
};

export const fetchSegmentsV2Response = (segmentData: any) => {
  return {
    type: actionTypes.FETCH_SEGMENTSV2_RESPONSE,
    segmentData,
  };
};

export const fetchSegmentsV2Error = (error: string) => {
  return {
    type: actionTypes.FETCH_SEGMENTSV2_ERROR,
    error,
  };
};

export const getInsightsFiltersRequest = (queryData: Record<string, any>) => {
  return {
    type: actionTypes.GET_INSIGHTS_FILTERS_REQUEST,
    queryData,
  };
};

export const getInsightsFiltersResponse = (response: Record<string, any>) => {
  return {
    type: actionTypes.GET_INSIGHTS_FILTERS_RESPONSE,
    response,
  };
};

export const getInsightsFiltersError = (error: string) => {
  return {
    type: actionTypes.GET_INSIGHTS_FILTERS_ERROR,
    error,
  };
};

export const getPreviewThumbnailsRequest = (queryData: Record<string, any>) => {
  return {
    type: actionTypes.GET_PREVIEW_THUMBNAILS_REQUEST,
    queryData,
  };
};

export const getPreviewThumbnailsResponse = (response: Record<string, any>) => {
  return {
    type: actionTypes.GET_PREVIEW_THUMBNAILS_RESPONSE,
    response,
  };
};

export const getPreviewThumbnailsError = (error: string) => {
  return {
    type: actionTypes.GET_PREVIEW_THUMBNAILS_ERROR,
    error,
  };
};

export const setInsightsFiltersRequest = (postData: Record<string, any>) => {
  return {
    type: actionTypes.SET_INSIGHTS_FILTERS_REQUEST,
    postData,
  };
};

export const setInsightsFiltersResponse = (response: Record<string, any>) => {
  return {
    type: actionTypes.SET_INSIGHTS_FILTERS_RESPONSE,
    response,
  };
};

export const setInsightsFiltersError = (error: string) => {
  return {
    type: actionTypes.SET_INSIGHTS_FILTERS_ERROR,
    error,
  };
};

export const csvExport = () => {
  return {
    type: actionTypes.CSV_EXPORT,
  };
};

export const fetchCampaignsRequest = (queryData: Record<string, any>) => {
  return {
    type: actionTypes.FETCH_CAMPAIGNS_REQUEST,
    queryData,
  };
};

export const fetchCampaignsResponse = (response: Record<string, any>) => {
  return {
    type: actionTypes.FETCH_CAMPAIGNS_RESPONSE,
    response,
  };
};

export const fetchCampaignsError = (error: Record<string, any>) => {
  return {
    type: actionTypes.FETCH_CAMPAIGNS_ERROR,
    error,
  };
};

export const exportCampaignsAsCsvRequest = (
  queryData: Record<string, any>,
  callback: (csvData: string) => void,
) => {
  return {
    type: actionTypes.EXPORT_CAMPAIGNS_AS_CSV_REQUEST,
    queryData,
    callback,
  };
};

export const exportCampaignsAsCsvResponse = (response: Record<string, any>) => {
  return {
    type: actionTypes.EXPORT_CAMPAIGNS_AS_CSV_RESPONSE,
    response,
  };
};

export const exportCampaignsAsCsvError = () => {
  return {
    type: actionTypes.EXPORT_CAMPAIGNS_AS_CSV_ERROR,
  };
};

export const exportDestinationsAsCsvRequest = (
  queryData: Record<string, any>,
  callback: (csvData: string) => void,
) => {
  return {
    type: actionTypes.EXPORT_DESTINATIONS_AS_CSV_REQUEST,
    queryData,
    callback,
  };
};

export const exportDestinationsAsCsvResponse = (response: Record<string, any>) => {
  return {
    type: actionTypes.EXPORT_DESTINATIONS_AS_CSV_RESPONSE,
    response,
  };
};

export const exportDestinationsAsCsvError = () => {
  return {
    type: actionTypes.EXPORT_DESTINATIONS_AS_CSV_ERROR,
  };
};

export const fetchSortedCampaignIdsByMultiMediumMetricRequest = (
  queryData: Record<string, any>,
) => {
  return {
    type: actionTypes.FETCH_SORTED_CAMPAIGN_IDS_BY_MULTI_MEDIUM_METRIC_REQUEST,
    queryData,
  };
};

export const fetchSortedCampaignIdsByMultiMediumMetricResponse = (
  response: Record<string, any>,
) => {
  return {
    type: actionTypes.FETCH_SORTED_CAMPAIGN_IDS_BY_MULTI_MEDIUM_METRIC_RESPONSE,
    response,
  };
};

export const fetchSortedCampaignIdsByMultiMediumMetricError = () => {
  return {
    type: actionTypes.FETCH_SORTED_CAMPAIGN_IDS_BY_MULTI_MEDIUM_METRIC_ERROR,
  };
};

export const fetchAllMetricsForCampaignsRequest = (queryData: Record<string, any>) => {
  return {
    type: actionTypes.FETCH_ALL_METRICS_FOR_CAMPAIGNS_REQUEST,
    queryData,
  };
};

export const fetchAllMetricsForCampaignsResponse = (response: Record<string, any>) => {
  return {
    type: actionTypes.FETCH_ALL_METRICS_FOR_CAMPAIGNS_RESPONSE,
    response,
  };
};

export const fetchAllMetricsForCampaignsError = (error: Record<string, any>) => {
  return {
    type: actionTypes.FETCH_ALL_METRICS_FOR_CAMPAIGNS_ERROR,
    error,
  };
};

export const updateAppliedCrossMetrics = (crossMetrics: string[]) => {
  return {
    type: actionTypes.UPDATE_APPLIED_CROSS_METRICS,
    crossMetrics,
  };
};

export const updateAppliedMediums = (appliedMediums: string[]) => {
  return {
    type: actionTypes.UPDATE_APPLIED_MEDIUMS,
    appliedMediums,
  };
};

export const fetchSavedViewRequest = (viewId: number) => {
  return {
    type: actionTypes.FETCH_SAVED_VIEW_REQUEST,
    viewId,
  };
};

export const fetchSavedViewResponse = (response?: Record<string, any>) => {
  return {
    type: actionTypes.FETCH_SAVED_VIEW_RESPONSE,
    response,
  };
};

export const fetchSavedViewError = (error: Record<string, any>) => {
  return {
    type: actionTypes.FETCH_SAVED_VIEW_ERROR,
    error,
  };
};

export const createViewRequest = (view: Record<string, any>, callback: () => void) => {
  return {
    type: actionTypes.CREATE_VIEW_REQUEST,
    view,
    callback,
  };
};

export const createViewResponse = (view: Record<string, any>) => {
  return {
    type: actionTypes.CREATE_VIEW_RESPONSE,
    view,
  };
};

export const createViewError = (error: Record<string, any>) => {
  return {
    type: actionTypes.CREATE_VIEW_ERROR,
    error,
  };
};

export const updateViewRequest = (view: Record<string, any>, callback?: () => void) => {
  return {
    type: actionTypes.UPDATE_VIEW_REQUEST,
    view,
    callback,
  };
};

export const updateViewResponse = (view: Record<string, any>) => {
  return {
    type: actionTypes.UPDATE_VIEW_RESPONSE,
    view,
  };
};

export const updateViewError = (error: Record<string, any>) => {
  return {
    type: actionTypes.UPDATE_VIEW_ERROR,
    error,
  };
};

export const fetchSavedViewsInfiniteScrollRequest = (queryParams: string) => {
  return {
    type: actionTypes.FETCH_SAVED_VIEWS_INFINITE_SCROLL_REQUEST,
    queryParams,
  };
};

export const fetchSavedViewsInfiniteScrollResponse = (response: Record<string, any>) => {
  return {
    type: actionTypes.FETCH_SAVED_VIEWS_INFINITE_SCROLL_RESPONSE,
    response,
  };
};

export const fetchSavedViewsInfiniteScrollError = (error: Record<string, any>) => {
  return {
    type: actionTypes.FETCH_SAVED_VIEWS_INFINITE_SCROLL_ERROR,
    error,
  };
};

export const fetchRecentSavedViewsRequest = (queryParams: string) => {
  return {
    type: actionTypes.FETCH_RECENT_SAVED_VIEWS_REQUEST,
    queryParams,
  };
};

export const fetchRecentSavedViewsResponse = (response: Record<string, any>) => {
  return {
    type: actionTypes.FETCH_RECENT_SAVED_VIEWS_RESPONSE,
    response,
  };
};

export const fetchRecentSavedViewsError = (error: Record<string, any>) => {
  return {
    type: actionTypes.FETCH_RECENT_SAVED_VIEWS_ERROR,
    error,
  };
};

export const fetchProjectDefaultViewRequest = () => {
  return {
    type: actionTypes.FETCH_PROJECT_DEFAULT_VIEW_REQUEST,
  };
};

export const fetchProjectDefaultViewResponse = (response?: Record<string, any>) => {
  return {
    type: actionTypes.FETCH_PROJECT_DEFAULT_VIEW_RESPONSE,
    response,
  };
};

export const fetchProjectDefaultViewError = (error: Record<string, any>) => {
  return {
    type: actionTypes.FETCH_PROJECT_DEFAULT_VIEW_ERROR,
    error,
  };
};

export const deleteSavedViewsRequest = (view: Record<string, any>, callback: () => void) => {
  return {
    type: actionTypes.DELETE_SAVED_VIEWS_REQUEST,
    view,
    callback,
  };
};

export const fetchPDFReportRequest = (queryData: PDFReportQuery) => {
  return {
    type: actionTypes.FETCH_PDF_REPORT_REQUEST,
    queryData,
  };
};

export const fetchPDFReportResponse = (response: Record<string, any>) => {
  return {
    type: actionTypes.FETCH_PDF_REPORT_RESPONSE,
    response,
  };
};

export const fetchPDFReportError = (error: Record<string, any>) => {
  return {
    type: actionTypes.FETCH_PDF_REPORT_ERROR,
    error,
  };
};

export const resetPDFReport = (pdfReportUrl: string) => {
  return {
    type: actionTypes.RESET_PDF_REPORT,
    pdfReportUrl,
  };
};
